<template>
  <div class="robHouseCustomer" v-if="permisShow('抢盘抢客')">
    <div class="robHouseCustomer_wrap" v-for="(item,index) in diskList" :key="index">
      <div class="robHouseCustomer_wrap_header">
        <div class="header_left">
          <el-checkbox v-model="item.whetherOpen">{{item.type}}</el-checkbox>
          <span>{{index==0?"（长时间未跟进，则会提醒或抢盘）":"（长时间未跟进，则会提醒或抢客）"}}</span>
        </div>
        <div class="header_rigth">
          <div class="block">
            <span class="demonstration">预警颜色：</span>
            <el-color-picker v-model="item.warnColor"></el-color-picker>
          </div>
          <div class="block">
            <span class="demonstration">{{index==0?"抢盘":"抢客"}}颜色：</span>
            <el-color-picker v-model="item.robColor"></el-color-picker>
          </div>
        </div>
      </div>
      <div class="robHouseCustomer_wrap_body">
        <div class="wrap_body_item" v-for="(item1,index1) in item.list" :key="index1">
          <div class="body_title">
            <el-checkbox v-model="item1.whetherOpen"></el-checkbox>
            <span class="item_span">{{item1.type}}</span>
          </div>
          <div class="body_item" v-for="(item2,index2) in item1.levelSystemDTO" :key="index2">
            <el-checkbox v-model="item2.whetherOpen"></el-checkbox>
            <span class="item_span">
              <span :style="{'color':item.robColor}">{{item2.type}}</span>
            </span>
<!--            <el-input v-model="item2.numberOne" @input="item2.numberOne = item2.numberOne.replace(/[^1-9]/g, '');"></el-input>-->
<!--            <span :style="{'color':item.warnColor}">天未跟进提醒本人；再过</span>-->
<!--            <el-input v-model="item2.numberTwo" @input="item2.numberTwo = item2.numberTwo.replace(/[^1-9]/g, '');"></el-input>-->
<!--            <span :style="{'color':item.warnColor,'margin-right':maright}">天未跟进提醒</span>-->
            <el-input v-model="item2.numberOne" @input="item2.numberOne = item2.numberOne.length===1?item2.numberOne.replace(/[^1-9]/g, ''):item2.numberOne.replace(/\D/g,'')"></el-input>
            <span :style="{'color':item.warnColor}">天未跟进提醒本人；再过</span>
            <el-input v-model="item2.numberTwo" @input="item2.numberTwo = item2.numberTwo.length===1?item2.numberTwo.replace(/[^1-9]/g, ''):item2.numberTwo.replace(/\D/g,'')"></el-input>
            <span :style="{'color':item.warnColor,'margin-right':maright}">天未跟进提醒</span>
            <div class="item_list" v-for="(item3,index3) in item2.list" :key="index3">
              <span class="item_list_title">{{item3.name}}</span>
              <img src="../../assets/robHouseCustomer/guanbi.png" alt="删除" class="item_list_img" @click="delectItem(index,index1,index2,index3)" />
              <img src="../../assets/robHouseCustomer/jiantou.png" style="margin:0 4px;" />
            </div>
            <img src="../../assets/robHouseCustomer/tianjia.png" @click="openWidnow(index,index1,index2)" style="cursor:pointer;margin:0 4px;" />
            <span class="item_span" :style="{'color':item.robColor}">进入{{index==0?"抢盘":"抢客"}}池</span>
          </div>
        </div>
      </div>
      <div class="robHouseCustomer_wrap_footer">
        <div class="wrap_footer_left">
          <span>{{index==0?"房源进入抢盘池":"客源进入抢客池"}}，需通知</span>
          <!-- <el-select v-model="item.employee" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>-->
          <el-select v-model="item.employee" filterable placeholder="请选择员工">
            <el-option v-for="(item,index) in remindEmployeeList" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="wrap_footer_right" v-if="index==0">
          <span>官网和微站数据处理：</span>
          <template>
            <el-radio v-model="item.upDown" label="YES">自动下架官网和微站{{index==0?"房":"客"}}源数据</el-radio>
            <el-radio v-model="item.upDown" label="NO">不需要自动下架{{index==0?"房":"客"}}源，<span>进入抢{{index==0?"盘":"客"}}池的对外联系人为</span></el-radio>
          </template>
          <!-- <el-select v-model="item.webEmployee" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>-->
          <el-select v-model="item.webEmployee" filterable placeholder="请选择员工">
            <el-option v-for="(item,index) in remindEmployeeList" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <el-dialog title="选择岗位" :visible.sync="centerDialogVisible" width="15%">
      <div class="dialog_wrap">
        <span>岗位：</span>
        <el-select v-model="roleId" placeholder="请选择">
          <el-option v-for="item in messageList" :key="item.value" :label="item.name" :value="item.roleId"></el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addItem" v-points>确 定</el-button>
      </span>
    </el-dialog>
    <div class="btn" style="width:100%;height:100px;line-height:100px;text-align:center;">
      <el-button type="primary" @click="updateDiskList" v-points>保存</el-button>
    </div>
  </div>
</template>
<script>
import { queryDisk, updateDisk, queryCommon } from "@/api/systemSetup";
import { roleFind } from "@/api/manageCenter";
export default {
  data() {
    let permisList = JSON.parse(sessionStorage.getItem("permisList"));
    return {
      alertMsg: true,
      permisList,
      centerDialogVisible: false,
      remindEmployeeList: [],
      messageList: [],
      maright: "10px",
      aindex: "",
      aindex1: "",
      aindex2: "",
      value: "",
      diskList: [],
      roleId: "",
      showWindow: true
    };
  },

  mounted() {
    this.queryDiskList(); //查询详情
    this.getRemindEmployee(); //获取所有员工
    this.Getmessage(); //获取所有岗位
  },

  methods: {
    permisShow(data) {
      // 权限配置
      let result = this.permisList.indexOf(data);
      if (result >= 0) {
        return true;
      } else {
        return false;
      }
    },
    //查询详情
    queryDiskList() {
      this.$post(queryDisk).then(res => {
        if (res.success) {
          this.diskList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //编辑
    updateDiskList() {
      for (let item of this.diskList) {
        if (item.type == "开启抢盘模式") {
          // if (item.upDown == "YES") {
          //   if (!item.webEmployee) {
          //     this.$message.error("请选择对外联系人");
          //     this.alertMsg = false;
          //   } else {
          //     this.alertMsg = true;
          //   }
          // }
          for (let item1 of item.list) {
            if (item1.type == "出售房源") {
              for (let item2 of item1.levelSystemDTO) {
                if (item2.type == "A类房源") {
                  if (item2.whetherOpen) {
                    if (!item2.numberOne || !item2.numberTwo) {
                      this.$message.error("请输入出售A类房源跟进天数");
                      this.alertMsg = false;

                      return;
                    } else {
                      this.alertMsg = true;
                    }
                  }
                } else if (item2.type == "B类房源") {
                  if (item2.whetherOpen) {
                    if (!item2.numberOne || !item2.numberTwo) {
                      this.$message.error("请输入出售B类房源跟进天数");
                      this.alertMsg = false;
                      return;
                    } else {
                      this.alertMsg = true;
                    }
                  }
                } else if (item2.type == "C类房源") {
                  if (item2.whetherOpen) {
                    if (!item2.numberOne || !item2.numberTwo) {
                      this.$message.error("请输入出售C类房源跟进天数");
                      this.alertMsg = false;
                      return;
                    } else {
                      this.alertMsg = true;
                    }
                  }
                } else if (item2.type == "D类房源") {
                  if (item2.whetherOpen) {
                    if (!item2.numberOne || !item2.numberTwo) {
                      this.$message.error("请输入出售D类房源跟进天数");
                      this.alertMsg = false;
                      return;
                    } else {
                      this.alertMsg = true;
                    }
                  }
                }
              }
            } else if (item1.type == "出租房源") {
              for (let item2 of item1.levelSystemDTO) {
                if (item2.type == "A类房源") {
                  if (item2.whetherOpen) {
                    if (!item2.numberOne || !item2.numberTwo) {
                      this.$message.error("请输入出租A类房源跟进天数");
                      this.alertMsg = false;
                      return;
                    } else {
                      this.alertMsg = true;
                    }
                  }
                } else if (item2.type == "B类房源") {
                  if (item2.whetherOpen) {
                    if (!item2.numberOne || !item2.numberTwo) {
                      this.$message.error("请输入出租B类房源跟进天数");
                      this.alertMsg = false;
                      return;
                    } else {
                      this.alertMsg = true;
                    }
                  }
                } else if (item2.type == "C类房源") {
                  if (item2.whetherOpen) {
                    if (!item2.numberOne || !item2.numberTwo) {
                      this.$message.error("请输入出租C类房源跟进天数");
                      this.alertMsg = false;
                      return;
                    } else {
                      this.alertMsg = true;
                    }
                  }
                } else if (item2.type == "D类房源") {
                  if (item2.whetherOpen) {
                    if (!item2.numberOne || !item2.numberTwo) {
                      this.$message.error("请输入出租D类房源跟进天数");
                      this.alertMsg = false;
                      return;
                    } else {
                      this.alertMsg = true;
                    }
                  }
                }
              }
            }
          }

        } else if (item.type == "开启抢客模式") {
          for (let item1 of item.list) {
            if (item1.type == "求购客源") {
              for (let item2 of item1.levelSystemDTO) {
                if (item2.type == "A级客户") {
                  if (item2.whetherOpen) {
                    if (!item2.numberOne || !item2.numberTwo) {
                      this.$message.error("请输入求购A级客户跟进天数");
                      this.alertMsg = false;
                      return;
                    } else {
                      this.alertMsg = true;
                    }
                  }
                } else if (item2.type == "B级客户") {
                  if (item2.whetherOpen) {
                    if (!item2.numberOne || !item2.numberTwo) {
                      this.$message.error("请输入求购B级客户跟进天数");
                      this.alertMsg = false;
                      return;
                    } else {
                      this.alertMsg = true;
                    }
                  }
                } else if (item2.type == "C级客户") {
                  if (item2.whetherOpen) {
                    if (!item2.numberOne || !item2.numberTwo) {
                      this.$message.error("请输入求购C级客户跟进天数");
                      this.alertMsg = false;
                      return;
                    } else {
                      this.alertMsg = true;
                    }
                  }
                } else if (item2.type == "D级客户") {
                  if (item2.whetherOpen) {
                    if (!item2.numberOne || !item2.numberTwo) {
                      this.$message.error("请输入求购D级客户跟进天数");
                      this.alertMsg = false;
                      return;
                    } else {
                      this.alertMsg = true;
                    }
                  }
                }
              }
            } else if (item1.type == "求租客源") {
              for (let item2 of item1.levelSystemDTO) {
                if (item2.type == "A级客户") {
                  if (item2.whetherOpen) {
                    if (!item2.numberOne || !item2.numberTwo) {
                      this.$message.error("请输入求租A级客户跟进天数");
                      this.alertMsg = false;
                      return;
                    } else {
                      this.alertMsg = true;
                    }
                  }
                } else if (item2.type == "B级客户") {
                  if (item2.whetherOpen) {
                    if (!item2.numberOne || !item2.numberTwo) {
                      this.$message.error("请输入求租B级客户跟进天数");
                      this.alertMsg = false;
                      return;
                    } else {
                      this.alertMsg = true;
                    }
                  }
                } else if (item2.type == "C级客户") {
                  if (item2.whetherOpen) {
                    if (!item2.numberOne || !item2.numberTwo) {
                      this.$message.error("请输入求租C级客户跟进天数");
                      this.alertMsg = false;
                      return;
                    } else {
                      this.alertMsg = true;
                    }
                  }
                } else if (item2.type == "D级客户") {
                  if (item2.whetherOpen) {
                    if (!item2.numberOne || !item2.numberTwo) {
                      this.$message.error("请输入求租D级客户跟进天数");
                      this.alertMsg = false;
                      return;
                    } else {
                      this.alertMsg = true;
                    }
                  }
                }
              }
            }
          }
        }
      }
      if (!this.alertMsg) {
        return;
      }
      let diskLists = Object.assign([], this.diskList);
      diskLists = JSON.stringify(diskLists);
      let params = {
        publicDisks: diskLists
      };
      this.$post(updateDisk, params).then(res => {
        if (res.success) {
          this.$message.success(res.msg);
          this.queryDiskList(); //查询详情
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //获取所有员工
    getRemindEmployee() {
      let params = {
        type: "ALL"
      };
      this.$post(queryCommon, params).then(res => {
        if (res.success) {
          this.remindEmployeeList = res.data.allEmployeeNames;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //  查询岗位
    Getmessage() {
      let params = {
        status: "ENABLE"
      };
      this.$post(roleFind, params).then(res => {
        if (res.success === true) {
          this.messageList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //删除提醒人
    delectItem(index, index1, index2, index3) {
      this.diskList[index].list[index1].levelSystemDTO[index2].list.splice(
        index3,
        1
      );
    },
    //新增窗口
    openWidnow(index, index1, index2) {
      this.centerDialogVisible = true;
      this.aindex = index;
      this.aindex1 = index1;
      this.aindex2 = index2;
    },
    //新增提醒人
    addItem() {
      if (!this.roleId) {
        this.$message.error("请选择岗位");
        return;
      }
      if (
        this.diskList[this.aindex].list[this.aindex1].levelSystemDTO[
          this.aindex2
        ].list.length > 0
      ) {
        for (let item of this.diskList[this.aindex].list[this.aindex1]
          .levelSystemDTO[this.aindex2].list) {
          if (item.roleId == this.roleId) {
            this.$message.error("岗位已存在");
            this.showWindow = false;
            break;
          } else {
            this.showWindow = true;
          }
        }
      }

      if (this.showWindow) {
        let remindData = {
          roleId: "",
          name: ""
        };
        this.messageList.map((item, index) => {
          if (item.roleId == this.roleId) {
            remindData.roleId = item.roleId;
            remindData.name = item.name;
          }
        });
        this.diskList[this.aindex].list[this.aindex1].levelSystemDTO[
          this.aindex2
        ].list.push(remindData);
        this.centerDialogVisible = false;
      }
    }
  }
};
</script>
<style lang='less'>
.robHouseCustomer {
  padding: 0 20px;
  font-size: 14px;
  background: #fff;
  .dialog_wrap {
    padding: 20px;
    .el-input {
      .el-input__inner {
        height: 30px;
        line-height: 30px;
        .el-input__icon {
          height: 30px;
          line-height: 30px;
        }
      }
    }
  }
  .robHouseCustomer_wrap {
    border-bottom: 8px solid #f7f8fc;
    .robHouseCustomer_wrap_header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px 0;
      border-bottom: 1px solid #dcdfe6;
      .header_left {
        > span {
          color: #ff8000;
        }
      }
      .header_rigth {
        display: flex;
        .block {
          display: flex;
          align-items: center;
          .el-color-picker {
            width: 80px;
            height: 24px;
            margin-right: 10px;
            .el-color-picker__trigger {
              width: 80px;
              height: 24px;
              padding: 0;
              border: none;
              .el-color-picker__color {
                border: none;
              }
            }
          }
        }
      }
    }
    .robHouseCustomer_wrap_body {
      padding-bottom: 20px;
      border-bottom: 1px solid #dcdfe6;
      .wrap_body_item {
        padding-top: 20px;
        .body_title {
          margin-bottom: 10px;
          .item_span {
            margin-left: 10px;
            font-weight: bold;
          }
        }
        .body_item {
          display: flex;
          align-items: center;
          margin-bottom: 16px;
          .item_span {
            margin-left: 10px;
          }
          .item_list {
            margin-right: 8px;
            // height: 30px;
            display: flex;
            align-items: center;
            .item_list_title {
              color: #5e75e6;
            }
            .item_list_img {
              margin: 0 4px;
              cursor: pointer;
            }
          }
          .el-checkbox {
            .el-checkbox__label {
              margin-right: 10px;
            }
          }
          .el-input {
            width: 80px;
            margin: 0 10px;
            .el-input__inner {
              width: 80px;
              height: 30px;
              line-height: 30px;
            }
          }
        }
        .body_item:last-child {
          margin: 0;
        }
      }
    }
    .robHouseCustomer_wrap_footer {
      display: flex;
      align-items: center;
      padding: 20px 0;
      .wrap_footer_left {
        margin-right: 20px;
      }
      .el-select {
        padding: 0 10px;
        .el-input__inner {
          width: 130px;
          height: 30px;
          line-height: 30px;
          .el-input__icon {
            height: 30px;
            line-height: 30px;
          }
        }
      }
    }
  }
  .robHouseCustomer_wrap:nth-child(2) {
    border-bottom: none;
  }
}
</style>